import type { Platform, Shortcuts } from '@lyrmo/shared/shortcuts';
import { createContext } from 'react';

/** Hosts such as the desktop app keep shortcuts in their own settings. */
export const EditorShortcutsContext = createContext<{
  readonly platform: Platform;
  readonly shortcuts: Shortcuts;
} | null>(null);
